var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4555 -8600C-4555 -8601.1 -4554.1 -8602 -4553 -8602H13363C13364.1 -8602 13365 -8601.1 13365 -8600V32612C13365 32613.1 13364.1 32614 13363 32614H-4553C-4554.11 32614 -4555 32613.1 -4555 32612V-8600Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4553 -8601H13363V-8603H-4553V-8601ZM13364 -8600V32612H13366V-8600H13364ZM13363 32613H-4553V32615H13363V32613ZM-4554 32612V-8600H-4556V32612H-4554ZM-4553 32613C-4553.55 32613 -4554 32612.6 -4554 32612H-4556C-4556 32613.7 -4554.66 32615 -4553 32615V32613ZM13364 32612C13364 32612.6 13363.6 32613 13363 32613V32615C13364.7 32615 13366 32613.7 13366 32612H13364ZM13363 -8601C13363.6 -8601 13364 -8600.55 13364 -8600H13366C13366 -8601.66 13364.7 -8603 13363 -8603V-8601ZM-4553 -8603C-4554.66 -8603 -4556 -8601.66 -4556 -8600H-4554C-4554 -8600.55 -4553.55 -8601 -4553 -8601V-8603Z",
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1240,
    transform: "translate(-488 -361)",
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -304,
    y: -132,
    width: 1156,
    height: 235,
    rx: 16,
    fill: "#121418"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#04D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 8.66699L13.7394 12.9795C12.3153 14.6884 11.6033 15.5429 10.6665 15.5429C9.72975 15.5429 9.01771 14.6884 7.59362 12.9795L6.6665 11.867",
    stroke: "#04D9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.412e9a1bb41308fb7097c6da4f9409cf.svg";
export { ForwardRef as ReactComponent };